import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IEventSFilter } from 'src/@types/SearchFilterTypes';

import { Page } from '../../../../components/Page';

import EventGrid from './EventGrid';
import SearchForm from './SearchForm';

/** * ## Event
 * 회사의 이벤트(스케줄) 관리
 */

export const Event = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IEventSFilter>>({});

  // 목록 검색
  const onSearch = (data: IEventSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <EventGrid searchData={searchData} />
    </Page>
  );
});
export default Event;
